import React from "react";
import PropTypes from "prop-types";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import RegisterHeroColumn from "./components/RegisterHeroColumn";

export const registerFormColumnSx = {
  width: { xs: "100%", sm: "40%" },
  display: "flex",
  paddingTop: "4vh",
  paddingBottom: "140px",
  flexDirection: "column",
  alignItems: "center",
  position: "relative",
  height: "100%",
  overflowY: "auto",
};

export const registerFormInnerSx = {
  width: "90%",
  maxWidth: "480px",
  backgroundColor: "transparent",
  p: { xs: 3, sm: 4 },
  position: "relative",
  my: "auto",
};

/**
 * Shared two-column registration shell (hero left, form right).
 * Pages keep their hooks/state and pass form content as children.
 */
export default function RegisterPageScaffold({
  config,
  children,
  bottomBar,
  dialogs,
  minHeight,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      display="flex"
      flexDirection="row"
      height={minHeight ? undefined : "100vh"}
      minHeight={minHeight ?? undefined}
      sx={{ position: "relative", overflow: "hidden" }}
      data-testid="register-page"
    >
      <RegisterHeroColumn isMobile={isMobile} />

      <Box
        sx={{
          ...registerFormColumnSx,
          width: isMobile ? "100%" : "40%",
          backgroundColor: "#fafafa",
          background: isMobile
            ? "white"
            : "linear-gradient(135deg, #fafafa 0%, #f0f0f0 100%)",
          "&::before": isMobile
            ? {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "transparent",
                pointerEvents: "none",
              }
            : {},
        }}
        data-register-variant={config?.id}
      >
        {children}
        {bottomBar}
      </Box>
      {dialogs}
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
      `}</style>
    </Box>
  );
}

RegisterPageScaffold.propTypes = {
  config: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
  }),
  children: PropTypes.node,
  bottomBar: PropTypes.node,
  dialogs: PropTypes.node,
  minHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
